export const signOut = () => {
  // Clear any auth tokens/state
  localStorage.removeItem('token');
  // Add any other cleanup needed for your auth system
}; 